// === IMPORTS ===
import React from 'react';
import { AlertTriangle, X, ShieldAlert, Layers } from 'lucide-react';
import '../styles/twin-modals-shared.css';
import './OverlapAlertModal.css';

interface OverlapAlertModalProps {
  isOpen: boolean;
  onClose: () => void;
  targetRoomName?: string;
  conflictingRoomName?: string;
  actionContext?: 'create' | 'resize' | 'move' | 'edit';
}

// === COMPONENTE: MODAL DE ALERTA POR SOLAPAMIENTO DE ZONAS ===
export const OverlapAlertModal: React.FC<OverlapAlertModalProps> = ({
  isOpen,
  onClose,
  targetRoomName = 'the selected zone',
  conflictingRoomName,
  actionContext = 'resize',
}) => {
  if (!isOpen) return null;

  return (
    <div className="twin-modal-overlay">
      <div className="twin-modal twin-modal--padded twin-overlap-alert-modal">
        {/* === BARRA DE ACENTO SUPERIOR === */}
        <div className="twin-modal-accent-bar twin-overlap-alert-accent" />

        {/* === BOTÓN CERRAR === */}
        <button
          type="button"
          onClick={onClose}
          className="twin-modal-close-btn"
          title="Close alert"
        >
          <X className="twin-icon-md" />
        </button>

        {/* === HEADER: ÍCONO + TÍTULO === */}
        <div className="twin-modal-header">
          <div className="twin-modal-icon-circle twin-overlap-alert-icon-circle">
            <ShieldAlert className="twin-icon-xl twin-icon-pulse" />
          </div>
          <div className="twin-overlap-alert-title-block">
            <h3 className="twin-modal-title">
              <span>Unsupported Action</span>
            </h3>
            <p className="twin-overlap-alert-subtitle">
              Zones cannot overlap on the floor plan
            </p>
          </div>
        </div>

        {/* === CUERPO: DESCRIPCIÓN === */}
        <div className="twin-modal-description-box">
          <div className="twin-overlap-alert-reason-row">
            <AlertTriangle className="twin-icon-sm twin-overlap-alert-reason-icon" />
            <span>
              {actionContext === 'resize' && 'Cannot resize over another existing zone.'}
              {actionContext === 'create' && 'Cannot create a zone over another existing zone.'}
              {actionContext === 'edit' && 'The entered dimensions or coordinates overlap with another zone.'}
              {actionContext === 'move' && 'Cannot move the area over another zone.'}
            </span>
          </div>

          <p className="twin-modal-description-text">
            {conflictingRoomName ? (
              <>
                The space assigned for <strong className="twin-overlap-alert-strong-white">{targetRoomName}</strong> directly collides with zone <strong className="twin-overlap-alert-strong-amber">{conflictingRoomName}</strong>.
              </>
            ) : (
              <>
                The area for <strong className="twin-overlap-alert-strong-white">{targetRoomName}</strong> overlaps with the boundaries of another defined zone.
              </>
            )}
          </p>

          <div className="twin-overlap-alert-footnote">
            <Layers className="twin-icon-sm twin-overlap-alert-footnote-icon" />
            <span>
              Each zone must occupy an independent physical space on the grid to ensure proper agent pathfinding, room capacity, and policy enforcement.
            </span>
          </div>
        </div>

        {/* === FOOTER: BOTÓN DE ACCIÓN ÚNICO === */}
        <div className="twin-overlap-alert-footer">
          <button
            type="button"
            onClick={onClose}
            className="twin-btn twin-btn--warning twin-overlap-alert-confirm-btn"
          >
            <span>Understood, adjust layout</span>
          </button>
        </div>
      </div>
    </div>
  );
};